import React from 'react';

/**
 * props:
 * - data
 * - onEditClick
 * - onStopClick
 * - onStartClick
 * - onDeleteClick
 */
function ProdutosRow(props) {


    function getDate(timestamp) {
        const date = new Date(timestamp);
        return Intl.DateTimeFormat('pt-BR', {
            dateStyle: 'short',
            timeStyle: 'short'
        })
            .format(date);
    }

    // function getStatus(status) {
    //     let className;
    //     switch (status) {
    //         case 1: className = 'badge bg-success py-1'; break;
    //         case 0: className = 'badge bg-danger py-1'; break;
    //         default: className = 'badge bg-warning py-1';
    //     }
    //     //     return (<span className={className}>{status.split('_')[0]}</span>)
    //     return (<span className={className}> {status}</span>)
    // }
    // function getStatus(ativo) {
    //     return ativo ? "badge bg-success py-1" : "text-danger";
    // }

    // function getActiveText(isActive) {
    //     return isActive ? "RUNNING" : "STOPPED";
    // }

    return (
        <tr>
            <td>
                <button id={"view" + props.data.id} type="button" className="btn btn-info btn-xs" data-bs-toggle="modal" data-bs-target="#modalViewOrder">
                    <svg className="icon icon-xs" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" /><path fillRule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clipRule="evenodd" />
                    </svg>
                </button>

                {/* excluir informação */}
                <button id={"view" + props.data.id} type="button" className="btn btn-danger btn-xs ms-2" data-bs-toggle="modal" data-bs-target="#deviceModal" onClick={props.onDeleteClick}>
                    <svg className="icon icon-xs" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
                    </svg>
                </button>

                <button id={"edit" + props.data.id} type="button" className="btn btn-secondary btn-xs ms-2" title="Edit this Produto" data-bs-toggle="modal" data-bs-target="#modalProduto" onClick={props.onEditClick}>
                    <svg className="icon icon-xs" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                    </svg>
                </button>
            </td>

            <td>
                {props.data.id}
            </td>
            <td>
                {props.data.nome}
            </td>
            <td>
                {props.data.descricao}
            </td>
            <td>
                {props.data.quantidade}
            </td>

            <td>
                {props.data.preco}
            </td>
            <td>

                <span className="fw-normal">{getDate(props.data.updatedAt)}</span>
            </td>
            <td>
                {
                    props.data.isActive
                        ? <svg className="icon icon-xs me-2" fill="green" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" /></svg>
                        : <svg className="icon icon-xs me-2" fill="red" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" /></svg>
                }
            </td>

            {/* <td> {props.data.bateria} </td> */}

        </tr>
    )
}

export default ProdutosRow;